export const UserRegister = {
	// Step 1
	'Enrollment Form': 'Formulario de Inscripción',
	'Already registered? Sign in!': '¿Ya estás registrado? ¡Inicia sesión!',
	'Register now': 'Regístrate',
	// Step 2
	'Verify your identity': 'Verifica tu identidad',
};
